export const searchSelector = state => state.restoreDeletedBusiness.search;
export const businessInfoSelector = state =>
  state.restoreDeletedBusiness.businessInfo;
export const submitSelector = state => state.restoreDeletedBusiness.submit;
export const logSelector = state => state.restoreDeletedBusiness.log;
